import _ from 'lodash';
import Vue from 'vue';

export const STATUS_LOADED = 'STATUS_LOADED';

export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_OPERATION = 'UPDATE_OPERATION';
export const CHANGE_LOADING = 'CHANGE_LOADING';
export const LOAD_DOCUMENT_TYPE = 'LOAD_DOCUMENT_TYPE';
export const REMOVE_DOCUMENT_TYPE = 'REMOVE_DOCUMENT_TYPE';

export const loadDocumentTypesAction = 'loadDocumentTypesAction';
export const saveDocumentTypeAction = 'saveDocumentTypeAction';
export const removeDocumentTypeAction = 'removeDocumentTypeAction';

export const loadOperationAction = 'loadOperationAction';

export const saveDocumentAction = 'saveDocumentAction';
export const removeDocumentAction = 'removeDocumentAction';
export const createFileOnServerAction = 'createFileOnServerAction';
export const clearModuleAction = 'clearModuleAction';

export const operationDocumentsGetter = 'operationDocuments';
export const getDocumentTypesGetter = 'getDocumentTypes';
export const getDocumentTypesListGetter = 'getDocumentTypesList';

function initialState() {
  return {
    error: '',
    loading: {
      types: STATUS_LOADED,
      operation: STATUS_LOADED,
    },
    types: {},
    operation: null,
  };
}

function fileReader(file) {
  return new Promise((resolve) => {
    const fr = new FileReader();
    fr.onload = resolve;
    fr.readAsDataURL(file);
  });
}

async function readFileFromLocal(file) {
  const rawData = await fileReader(file).then(event => event.target.result);
  return rawData.substr(rawData.lastIndexOf('base64') + 7);  // As before works
  // return rawData;
}

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    [CLEAR_MODULE](state) {
      Vue.set(state, 'types', {});
      Vue.set(state, 'loading', {
        types: STATUS_LOADED,
        operation: STATUS_LOADED,
      });
      Vue.set(state, 'error', '');
      Vue.set(state, 'operation', null);
    },
    [UPDATE_OPERATION](state, payload) {
      Vue.set(state, 'operation', payload);
    },
    [CHANGE_LOADING](state, payload) {
      const { entity, status } = payload;
      Vue.set(state.loading, entity, status);
    },
    [LOAD_DOCUMENT_TYPE](state, payload) {
      const newState = _.cloneDeep(state.types);
      const { documentType, parent } = payload;
      if (parent) {
        if (!(parent in newState)) {
          newState[parent] = [];
        }
        newState[parent].splice(0, 0, documentType.id);
      } else if (!(documentType.id in newState)) {
        newState[documentType.id] = [];
      }
      state.types = newState;
    },
    [REMOVE_DOCUMENT_TYPE](state, payload) {
      const { documentType, parent } = payload;
      if (parent && Array.isArray(state.types[parent.id])) {
        const types = _.clone(state.types[parent.id]);
        const index = types[parent.id].indexOf(documentType.id);
        types.splice(index, 1);
        state.types[parent.id] = types;
      } else if (!payload.parent && payload.documentType && payload.documentType.id in state.types) {
        const newTree = Vue._.cloneDeep(state.types);
        delete newTree[documentType.id];
        state.types = newTree;
      }
    },
  },
  actions: {
    [clearModuleAction]({ commit }) {
      commit(CLEAR_MODULE);
    },
    async [loadOperationAction]({ commit, rootGetters, dispatch }, payload) {
      const operation = rootGetters['operation_model/entitiesGetter'][payload];
      if (operation) {
        const docIds = [
          ...(Array.isArray(operation.documents) ? operation.documents : []),
          ...(Array.isArray(operation.documentsNeeded) ? operation.documentsNeeded : []),
        ];
        if (Array.isArray(docIds) && docIds.length > 0) {
          const docsResponse = await dispatch('document_model/fetchAction', {
            uuidFilter: {
              modelName: 'uuid',
              operator: 'IN',
              value: docIds,
              path: 'uuid',
            },
          }, { root: true });
          const ids = docsResponse.entities.map(e => e.id);
          await dispatch('fileImage_model/fetchAction', {
            documentFilter: {
              path: 'uuid',
              operator: 'IN',
              value: ids,
              parent: 'node--document',
              parentProperty: 'file',
            },
          }, { root: true });
          await dispatch('fileDocument_model/fetchAction', {
            documentFilter: {
              path: 'uuid',
              operator: 'IN',
              value: ids,
              parent: 'node--document',
              parentProperty: 'file',
            },
          }, { root: true });
        }
        commit(UPDATE_OPERATION, operation);
      }
    },
    async [createFileOnServerAction]({ dispatch }, payload) {
      const { file, user, operation, title, uri, reputation } = payload;
      // new api
      // const value = `public://operations/${operation.id}/${title}`;
      // const url = await readFileFromLocal(file);
      // const uri = [{ value, url }];
      // const newFile = { filename: file.name, filesize: file.size, filemime: file.type, user: user.id, uri };
      // old api

      let newUri;
      if (!uri) {
        if (!_.isNil(operation)) {
          newUri = `public://operations/${operation.id}/${title}`;
        } else if (!_.isNil(reputation)) {
          newUri = `public://reputations/${reputation.id}/${title}`;
        } else {
          newUri = `public://nexumFiles/${title}`;
        }
      } else {
        newUri = uri;
      }
      const data = await readFileFromLocal(file);
      const newFile = { user: user.id, uri: newUri, data };
      let savedFile = null;
      if (file.type.startsWith('image')) {
        newFile.type = 'file--image';
        // TODO, review contenta file updating
        // savedFile = await dispatch('fileImage_model/upsertEntityAction', newFile, { root: true });
        const nexumFile = await dispatch('nexumImage_model/upsertEntityAction', newFile, { root: true });
        const files = await dispatch('fileImage_model/fetchAction', { id: nexumFile.uuid }, { root: true });
        if (_.has(files, 'entities') && _.isArray(files.entities) && files.entities.length > 0) {
          savedFile = files.entities[0];
        }
      } else if (file.type.startsWith('application')) {
        newFile.type = 'file--document';
        const nexumFile = await dispatch('nexumDocument_model/upsertEntityAction', newFile, { root: true });
        const files = await dispatch('fileDocument_model/fetchAction', { id: nexumFile.uuid }, { root: true });
        if (_.has(files, 'entities') && _.isArray(files.entities) && files.entities.length > 0) {
          savedFile = files.entities[0];
        }
        savedFile = await dispatch('fileDocument_model/upsertEntityAction', newFile, { root: true });
      }
      return savedFile;
    },
    async [loadDocumentTypesAction]({ commit, dispatch }) {
      const documentTypes = await dispatch('documentType_model/fetchAction', {}, { root: true });
      documentTypes.entities.forEach(documentType => commit(LOAD_DOCUMENT_TYPE, { documentType, parent: documentType.parent }));
      commit(CHANGE_LOADING, { entity: 'types', status: STATUS_LOADED });
    },
    async [saveDocumentTypeAction]({ commit, dispatch }, payload) {
      const savedDocument = await dispatch('documentType_model/upsertEntityAction', payload, { root: true });
      commit(LOAD_DOCUMENT_TYPE, { documentType: savedDocument, parent: savedDocument.parent });
    },
    async [removeDocumentTypeAction]({ commit, dispatch }, payload) {
      const { documentType } = payload;
      await dispatch('documentType_model/removeEntityAction', documentType, { root: true });
      commit(REMOVE_DOCUMENT_TYPE, payload);
    },
    async [saveDocumentAction]({ commit, state, dispatch, rootGetters }, payload) {
      const { operation, document, file, reputation } = payload;
      const user = rootGetters.user;
      let savedFile = null;
      if (file) {
        savedFile = await dispatch(createFileOnServerAction, { file, user, operation, title: document.title, reputation });
      }
      if (savedFile) {
        document.file = { id: savedFile.id, type: savedFile.type };
      } else {
        document.file = null;
      }
      const savedDocument = await dispatch('document_model/upsertEntityAction', document, { root: true });
      // TODO improve document saving
      if (!_.isNil(operation)) {
        let savedOperation = null;
        if (Array.isArray(operation.documents)) {
          if (operation.documents.indexOf(savedDocument.id) === -1) {
            const documents = [savedDocument.id].concat(operation.documents);
            const newOperation = Object.assign({}, operation, { documents });
            savedOperation = await dispatch('operation_model/upsertEntityAction', newOperation, { root: true });
          }
        } else {
          const newOperation = Object.assign({}, operation, { documents: [savedDocument] });
          savedOperation = await dispatch('operation_model/upsertEntityAction', newOperation, { root: true });
        }
        if (savedOperation) {
          commit(UPDATE_OPERATION, savedOperation);
        }
      } else if (!_.isNil(reputation)) {
        const retutationToSave = _.assign({}, reputation, { document: savedDocument.id });
        await dispatch('reputation_model/upsertEntityAction', retutationToSave, { root: true });
      }
      return savedDocument;
    },
    async [removeDocumentAction]({ commit, dispatch }, payload) {
      const { document, operation, file } = payload;
      if (file && _.isString(document.file) && document.file !== '') {
        if (file.filemime.startsWith('image')) {
          await dispatch('fileImage_model/removeEntityAction', { id: document.file }, { root: true });
        } else if (file.type.startsWith('application')) {
          await dispatch('fileDocument_model/removeEntityAction', { id: document.file }, { root: true });
        }
      }
      await dispatch('document_model/removeEntityAction', document, { root: true });
      if (Array.isArray(operation.documents) && operation.documents.indexOf(document.id) !== -1) {
        const documents = operation.documents.filter(d => d !== document.id);
        const updatedOperation = _.merge({}, operation, { documents });
        await dispatch('operation_model/upsertEntityAction', updatedOperation, { root: true });
      }
    },
  },
  getters: {
    [operationDocumentsGetter]: (state) => {
      if (state.operation && Array.isArray(state.operation.documents)) {
        return state.operation.documents;
      }
      return [];
    },
    [getDocumentTypesGetter]: state => state.types,
    [getDocumentTypesListGetter]: (state, getters, rootState, rootGetters) => {
      const response = [];
      const documentTypes = rootGetters['documentType_model/entitiesGetter'];
      _.forOwn(state.types, (value, key) => {
        const rootType = documentTypes[key];
        response.push(rootType);
        value.forEach((typeId) => {
          const type = documentTypes[typeId];
          response.push(type);
        });
      });
      return response;
    },
  },
};



// WEBPACK FOOTER //
// ./src/features/documents/store.js